import { render, staticRenderFns } from "./QuestionNotVoted.vue?vue&type=template&id=4b05226e&scoped=true"
import script from "./QuestionNotVoted.vue?vue&type=script&lang=js"
export * from "./QuestionNotVoted.vue?vue&type=script&lang=js"
import style0 from "./QuestionNotVoted.vue?vue&type=style&index=0&id=4b05226e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05226e",
  null
  
)

export default component.exports